import React from "react"; 
import {Route, Redirect} from "react-router-dom";
import PropTypes from "prop-types";
import {connect } from "react-redux";
import cookie from 'react-cookies';

const GuestRoute = ( {isAuthenticated, component: Component, ...rest} ) => (
	<Route {...rest} render = { props => 
		!isAuthenticated ? ( <Component {...props} /> ) : (<Redirect to = "/main"/>) 
	} />
);

GuestRoute.propTypes = {
	isAuthenticated: PropTypes.bool.isRequired
}

function mapStateToProps (state) {
	return {
		// isAuthenticated: !!localStorage.BookAppLogin,
		isAuthenticated: !!state.user.name//token
	}
};

// ,
// 	component: PropTypes.func.isRequired

export default connect(mapStateToProps) (GuestRoute);
